export default function (element, data) {
    const items = JSON.parse(element.dataset.items);

    let diagramData = items.map(item => ({
        proportion: parseFloat(item.value),
        color: item.color,
        label: item.title
    }));

    createChart(element, {
        size: 270,
        outerRadius: 135,
        innerRadius: 0,
        labelColorLight: "#ffffff",
        labelColorDark: "#494746",
        labelFontSize: "16px",
        labelFontWeight: '500',
        labelVerticalOffset: 3,
        labelRadiusPos: 1.5,
    }, diagramData);

    const tooltip = document.createElement("div");
    tooltip.style.position = "absolute";
    tooltip.style.padding = "6px 10px";
    tooltip.style.background = "rgba(0, 0, 0, 0.8)";
    tooltip.style.color = "#fff";
    tooltip.style.borderRadius = "6px";
    tooltip.style.fontSize = "14px";
    tooltip.style.pointerEvents = "none";
    tooltip.style.opacity = "0";
    tooltip.style.transition = "opacity 0.15s ease";
    tooltip.style.whiteSpace = "nowrap";
    tooltip.style.zIndex = "1000";
    tooltip.style.transform = "translate(-50%, -5%)";
    element.style.position = "relative";
    element.appendChild(tooltip);

    function createChart(diagramElement, options, segments) {
        const size = options.size;
        const outerRadius = options.outerRadius;
        const innerRadius = options.innerRadius;
        const labelColorLight = options.labelColorLight;
        const labelColorDark = options.labelColorDark;
        const labelFontSize = options.labelFontSize;
        const labelFontWeight = options.labelFontWeight;
        const labelVerticalOffset = options.labelVerticalOffset;
        const labelRadiusPos = options.labelRadiusPos;

        const centerX = size / 2;
        const centerY = size / 2;

        const svgElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svgElement.setAttribute('fill', 'none');
        svgElement.setAttribute('viewBox', `0 0 ${size} ${size}`);
        svgElement.setAttribute('stroke', 'none');
        svgElement.style.width = size + "px";

        const total = segments.reduce((total, segment) => total + segment.proportion, 0);

        let currentPosition = -Math.PI / 2;
        for (const segment of segments) {
            const segmentSize = (segment.proportion / total) * Math.PI * 2;
            const d = createSegmentPath(centerX, centerY, outerRadius, innerRadius, currentPosition, currentPosition + segmentSize);

            // создаём группу, объединяющую сегмент и текст
            const group = document.createElementNS('http://www.w3.org/2000/svg', 'g');

            // основной сектор
            const segmentPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            segmentPath.setAttribute('d', d);
            segmentPath.setAttribute('fill', segment.color);
            segmentPath.setAttribute('stroke', segment.color);
            segmentPath.setAttribute('stroke-width', '0');
            group.appendChild(segmentPath);

            // текст внутри сегмента
            if (segment.proportion >= 3) {
                const textPos = currentPosition + segmentSize / 2;
                const radius = (innerRadius + outerRadius) / labelRadiusPos;
                const textX = Math.cos(textPos) * radius + centerX;
                const textY = Math.sin(textPos) * radius + centerY + labelVerticalOffset;

                const segmentText = document.createElementNS('http://www.w3.org/2000/svg', 'text');
                segmentText.setAttribute('text-anchor', 'middle');
                segmentText.setAttribute('x', textX);
                segmentText.setAttribute('y', textY);
                segmentText.style.fontSize = labelFontSize;
                segmentText.style.fontWeight = labelFontWeight;
                segmentText.style.pointerEvents = "none"; // чтобы курсор не перехватывал события
                segmentText.setAttribute(
                    'fill',
                    getColorLuma(segment.color) < 180 ? labelColorLight : labelColorDark
                );
                segmentText.textContent = segment.proportion + '%';
                group.appendChild(segmentText);
            }

            // общие обработчики для всей группы
            group.addEventListener('mouseover', () => {
                segmentPath.setAttribute('fill', darkenColor(segment.color, 0.1));
            });
            group.addEventListener('mouseout', () => {
                segmentPath.setAttribute('fill', segment.color);
                tooltip.style.opacity = "0";
            });
            group.addEventListener("mousemove", (e) => {
                const tooltipText = `${segment.label}:<br>${segment.proportion % 1 === 0 
                    ? segment.proportion 
                    : segment.proportion.toFixed(1)}%`;
                tooltip.innerHTML = tooltipText;

                const rect = diagramElement.getBoundingClientRect();
                const tooltipRect = tooltip.getBoundingClientRect();

                let left = e.clientX - rect.left + 10;
                let top = e.clientY - rect.top - tooltipRect.height - 10;

                if (tooltipRect.width > window.innerWidth * 0.9) {
                    tooltip.style.width = `${window.innerWidth * 0.7}px`;
                    tooltip.style.whiteSpace = "normal";
                    tooltip.style.transform = "translate(0, 0)";
                } else {
                    tooltip.style.width = "auto";
                    tooltip.style.whiteSpace = "nowrap";
                }

                const updatedRect = tooltip.getBoundingClientRect();

                if (left + updatedRect.width > rect.width) left = rect.width - updatedRect.width - 5;
                if (left < 0) left = 5;
                if (top < 0) top = e.clientY - rect.top + 15;

                tooltip.style.left = left + "px";
                tooltip.style.top = top + "px";
                tooltip.style.opacity = "1";
            });

            // добавляем группу в svg
            svgElement.appendChild(group);

            currentPosition += segmentSize;
        }
        diagramElement.appendChild(svgElement);
    }


    function createSegmentPath(centerX, centerY, outerRadius, innerRadius, sectorBegin, sectorEnd) {
        const point1X = Math.cos(sectorBegin) * outerRadius + centerX/* + offsetX*/;
        const point1Y = Math.sin(sectorBegin) * outerRadius + centerY/* + offsetY*/;

        const point2X = Math.cos(sectorEnd) * outerRadius + centerX/* + offsetX*/;
        const point2Y = Math.sin(sectorEnd) * outerRadius + centerY/* + offsetY*/;

        const point3X = Math.cos(sectorEnd) * innerRadius + centerX/* + offsetX*/;
        const point3Y = Math.sin(sectorEnd) * innerRadius + centerY/* + offsetY*/;

        const point4X = Math.cos(sectorBegin) * innerRadius + centerX/* + offsetX*/;
        const point4Y = Math.sin(sectorBegin) * innerRadius + centerY/* + offsetY*/;

        return `M ${point1X} ${point1Y} A ${outerRadius} ${outerRadius} 0 0 1 ${point2X} ${point2Y} L ${point3X} ${point3Y} A ${innerRadius} ${innerRadius} 0 0 0 ${point4X} ${point4Y} Z`;
    }

    function getColorLuma(color) {
        const c = color.substring(1);
        const rgb = parseInt(c, 16);

        const r = (rgb >> 16) & 0xff;
        const g = (rgb >> 8) & 0xff;
        const b = (rgb >> 0) & 0xff;

        return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    }
    function darkenColor(hex, amount = 0.1) {
        let c = hex.startsWith('#') ? hex.slice(1) : hex;
        if (c.length === 3) {
            c = c.split('').map(ch => ch + ch).join('');
        }
        const num = parseInt(c, 16);
        let r = (num >> 16) - (255 * amount);
        let g = ((num >> 8) & 0x00FF) - (255 * amount);
        let b = (num & 0x0000FF) - (255 * amount);
        r = Math.max(0, Math.min(255, r));
        g = Math.max(0, Math.min(255, g));
        b = Math.max(0, Math.min(255, b));
        return `rgb(${r},${g},${b})`;
    }
}